(ns practitest.frontend.common-old-fe.modal
  (:require
    [practitest.frontend.common-old-fe.logging :as log]
    [re-frame.core :as re-frame]))

(defn window
  "Modal dialog.
  `data-subscription` is the re-frame subscription used to retrieve metadata about the modal.
                      it should contain following keys:
                      `:show?` - boolean
                      `:size` - :extra-small, :small, :medium, :large, or :extra-large
                      `:dirty?` - if true, will confirm close
  `backdrop-click-event` is optional, if specified, will be dispatched when user clicks on the backdrop
  `escape-key-event` is optional, if specified, will be dispatched when user hits escape key
  `body` is required, it's the actual content of the modal dialog."
  [{:keys [data-subscription backdrop-click-event escape-key-event body]}]
  (let [data (re-frame/subscribe data-subscription)]
    (fn [_]
      [:div
       (when (:show? @data)
         [:div.rfm-modal-wrapper
          [:div.rfm-modal-backdrop
           {:on-click (when backdrop-click-event
                        (fn [e]
                          (when (or (not (:dirty? @data))
                                    (js/window.confirm "There are unsaved changes that will be lost. Are you sure?"))
                            (re-frame/dispatch backdrop-click-event)
                            (.preventDefault e)
                            (.stopPropagation e))))}]
          [:div.rfm-modal-child
           {:on-key-up (when escape-key-event
                         (fn [e]
                           (when (and (= 27 (.-which e))
                                      (or (not (:dirty? @data))
                                          (js/window.confirm "There are unsaved changes that will be lost. Are you sure?")))
                             (re-frame/dispatch escape-key-event))))
            :style     {:width    (case (get @data :size :medium)
                                    :extra-small "15%"
                                    :small "30%"
                                    :medium "50%"
                                    :large "65%"
                                    :extra-large "85%")
                        :overflow "auto"}}
           body]])])))
